import { apiEligiblePropTrading } from '@/resource/propTrading'
import { isSuccess } from '@/util/utils'

export default {
  async actionGetEligiblePropTrading({ commit, state }) {
    const result = await apiEligiblePropTrading()

    if (isSuccess(result.data)) {
      commit('SET_STATUS', result.data.data)
    } else {
      commit('SET_STATUS', {
        session: false,
        eligible: false,
        account: false,
      })
    }

    return result
  },
  actionChangeIsPropTrading: ({ commit }, value) => commit('SET_IS_PROP_TRADING_ACCOUNT', value),
}
